import HomeServicesItemCard from './HomeServicesItemCard';
export default HomeServicesItemCard;